/**
 * Moldura de ferramenta dentro do shell — D5 (30/Set/2026, prancha 00-B/2a).
 *
 * A página real (editor de playbooks, personas, bonds…) chega como `children` INTACTA:
 * gate de capability, estado e salvamento continuam dela (spec §4: ferramenta é dona do
 * próprio ciclo; NÃO entra na sticky bar). Aqui só o que diz «de onde vim»: o breadcrumb
 * Administração / <domínio> / <ferramenta>, porque o item do domínio no menu segue ativo
 * (`matchChildren`) mas o menu não lista a ferramenta — é o breadcrumb que a nomeia.
 */
import { Link } from 'react-router-dom';

import { CONFIG_CATALOG, DOMINIOS } from './catalog';

export function FerramentaPage({
  id,
  children,
}: {
  readonly id: string;
  readonly children: React.ReactNode;
}): JSX.Element {
  const item = CONFIG_CATALOG.find((i) => i.id === id);
  if (item?.natureza !== 'ferramenta') {
    throw new Error(`FerramentaPage: «${id}» não é ferramenta do catálogo`);
  }
  const dominio = DOMINIOS.find((d) => d.id === item.dominio)!;
  return (
    <div className="flex h-full flex-col">
      <p className="flex items-center gap-1.5 px-8 pt-6 text-xs text-text-secondary">
        <span>Administração</span>
        <span aria-hidden>/</span>
        <Link to={dominio.rota} className="hover:text-text-primary">
          {dominio.label}
        </Link>
        <span aria-hidden>/</span>
        <strong className="font-medium text-text-primary">{item.label}</strong>
      </p>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
